import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useApi } from '@backstage/core-plugin-api';
import { identityApiRef, analyticsApiRef } from '@backstage/core-plugin-api';

export const useLoginTracking = () => {
  const identity = useApi(identityApiRef);
  const analytics = useApi(analyticsApiRef);

  useEffect(() => {
    let isTracked = false;

    const trackLogin = async () => {
      try {
        const user = await identity.getBackstageIdentity();

        if (user && !isTracked) {
          isTracked = true;

          analytics.captureEvent({
            action: 'user_login',
            subject: 'user-login',
            context: {
              pluginId: 'core',
              extension: 'identity-provider',
              routeRef: 'root',
            },
            attributes: {
              user: user.userEntityRef,
              timestamp: new Date().toISOString(),
            },
          });
        }
      } catch (e) {
        console.warn('Login tracking failed', e);
      }
    };

    trackLogin();
  }, [identity, analytics]);
};

export const useExpandableNav = (basePath: string, additionalActivePaths: string[] = []) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(basePath) ||
    additionalActivePaths.some(p => location.pathname.startsWith(p));
  const [isExpanded, setIsExpanded] = useState(isActive);

  useEffect(() => {
    if (isActive) {
      setIsExpanded(true);
    }
  }, [isActive]);

  return { isExpanded, setIsExpanded, isActive };
};
